import React, { Component } from 'react';
import { Chart } from "react-google-charts";
import { colors } from '../../../../api';

class PieAndLegend extends Component {

    render(){
        const { title, data } = this.props;

        const pieOptions = {
            pieHole: 1,
            slices: [
                { color: colors[0] },
                { color: colors[1] },               
                { color: colors[2] },
                { color: colors[3] },
                { color: colors[4] },
                { color: colors[5] },
                { color: colors[6] },
                { color: colors[7] },
                { color: colors[8] },
                { color: colors[9] },
                { color: colors[10] },
                { color: colors[11] },
                { color: colors[12] },
                { color: colors[13] },                
                { color: colors[14] },
                { color: colors[15] },
                { color: colors[16] },
                { color: colors[17] },                
                { color: colors[18] },
                { color: colors[19] },
            ],
            tooltip: {
                showColorCode: false
            },
            chartArea: { left: 0, top: 0, width: '95%', height: '95%' },
            legend: "none"
        };
                
        return (   
        <div className="card">
            <div className="card-header">
                <h5>{title}</h5>
            </div>
            <div className="card-body">
                <div className="order-graph sm-order-space">
                    <div className="row">
                        <div className="col-xl-6 xl-100">   
                            <div className="peity-chart-dashboard text-center">
                                <Chart
                                    chartType="PieChart"
                                    data={data}
                                    options={pieOptions}
                                    width={"95%"}
                                    height={"95%"}
                                />
                            </div>
                        </div>
                        <div className="col-xl-6 xl-100">                                            
                            <div className="order-graph-bottom">
                                <div className="media">
                                    <div style={{
                                        backgroundColor: colors[5],
                                        width: "18px",
                                        height: "8px",
                                        marginTop: "7px",
                                        borderRadius: "4px"
                                    }}
                                    ></div>
                                    <div className="media-body">
                                        <h6 className="mb-0 mr-0">{data[0][0]} <span className="pull-right">{data[0][1]}</span></h6>
                                    </div>
                                </div>
                            {data.slice(1).map((x, index) => 
                                <div className="media">
                                    <div style={{
                                        backgroundColor: colors[index],
                                        width: "18px",
                                        height: "8px",
                                        marginTop: "7px",
                                        borderRadius: "4px"
                                    }}
                                    ></div>
                                    <div className="media-body">
                                        <h6 className="mb-0 mr-0">{x[0]} <span className="pull-right">{x[1]}</span></h6>
                                    </div>
                                </div>
                            )}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>                 
        )
    }
}

export default PieAndLegend
